<!-- ========================================================= -->
<!-- MODAL TIMELINE DOCUMENTO                                  -->
<!-- ========================================================= -->

<div class="flex flex-col gap-4 h-full">

  <!-- ======================================================= -->
  <!-- CABECERA                                                -->
  <!-- ======================================================= -->

  <div
    class="
      flex
      flex-col
      md:flex-row
      md:items-center
      md:justify-between
      gap-3
      p-4
      rounded-xl
      bg-surface-50
      border
      border-surface-200
    "
  >

    <div class="flex items-center gap-3">

      <div
        class="
          flex
          items-center
          justify-center
          w-12
          h-12
          rounded-full
          bg-primary
          text-white
        "
      >
        <i class="pi pi-history text-xl"></i>
      </div>

      <div>

        <div class="font-semibold text-lg">
          Timeline del documento
        </div>

        <div class="text-sm text-color-secondary">
          Documento:
          <span class="font-medium">
            {{ idfdArchivo || 'No disponible' }}
          </span>
        </div>

      </div>

    </div>


    <!-- BOTÓN REFRESCAR -->

    <p-button
      label="Actualizar"
      icon="pi pi-refresh"
      severity="secondary"
      [outlined]="true"
      [loading]="loadingTimeline"
      (onClick)="refrescarTimeline()"
    >
    </p-button>

  </div>


  <!-- ======================================================= -->
  <!-- INFORMACIÓN CABECERA                                    -->
  <!-- ======================================================= -->

  <div
    *ngIf="cabeceraTimeline"
    class="
      grid
      grid-cols-2
      md:grid-cols-3
      lg:grid-cols-5
      gap-3
    "
  >

    <!-- Eventos -->

    <div
      class="
        p-3
        rounded-xl
        bg-white
        border
        border-surface-200
      "
    >

      <div class="text-xs text-color-secondary">
        Eventos/Pasos
      </div>

      <div class="text-xl font-semibold">
        {{ totalEventos }}
      </div>

    </div>


    <!-- Estados -->

    <div
      class="
        p-3
        rounded-xl
        bg-white
        border
        border-surface-200
      "
    >

      <div class="text-xs text-color-secondary">
        Estados
      </div>

      <div class="text-xl font-semibold">
        {{ totalEstados }}
      </div>

    </div>


    <!-- Usuarios -->

    <div
      class="
        p-3
        rounded-xl
        bg-white
        border
        border-surface-200
      "
    >

      <div class="text-xs text-color-secondary">
        Usuarios
      </div>

      <div class="text-xl font-semibold">
        {{ totalUsuarios }}
      </div>

    </div>


    <!-- Estado actual -->

    <div
      class="
        col-span-2
        md:col-span-1
        lg:col-span-2
        p-3
        rounded-xl
        bg-white
        border
        border-surface-200
      "
    >

      <div class="text-xs text-color-secondary">
        Estado actual
      </div>

      <div class="font-semibold truncate">
        {{ estadoActual }}
      </div>

    </div>

  </div>


  <!-- ======================================================= -->
  <!-- INFORMACIÓN GENERAL DEL DOCUMENTO                       -->
  <!-- ======================================================= -->

   <div *ngIf="cabeceraTimeline">

  <p-accordion [multiple]="true">

    <p-accordion-panel value="info-documento">

      <!-- ========================================= -->
      <!-- CABECERA DEL ACORDEÓN -->
      <!-- ========================================= -->

      <p-accordion-header>

        <div class="flex items-center gap-2">

          <i class="pi pi-file text-primary"></i>

          <span class="font-semibold">
            Información del documento
          </span>

        </div>

      </p-accordion-header>


      <!-- ========================================= -->
      <!-- CONTENIDO -->
      <!-- ========================================= -->

      <p-accordion-content>

        <div
          class="
            grid
            grid-cols-1
            md:grid-cols-2
            lg:grid-cols-4
            gap-4
            pt-2
          "
        >

          <!-- ===================================== -->
          <!-- Flujo -->
          <!-- ===================================== -->

          <div>

            <div class="text-xs text-color-secondary">
              Flujo documental
            </div>

            <div class="font-medium">
              {{ cabeceraTimeline.CabeceraNombreFlujo || 'No disponible' }}
            </div>

          </div>


          <!-- ===================================== -->
          <!-- Paso -->
          <!-- ===================================== -->

          <div>

            <div class="text-xs text-color-secondary">
             <b>Paso actual</b>
            </div>

            <div class="font-medium">

              {{ cabeceraTimeline.IdfdPaso || '' }}

              {{ cabeceraTimeline.IdfdPaso ? ' - ' : '' }}

              {{ cabeceraTimeline.NombrePaso || 'No disponible' }}

            </div>

          </div>


          <!-- ===================================== -->
          <!-- Tarea -->
          <!-- ===================================== -->

          <div>

            <div class="text-xs text-color-secondary">
              Tarea
            </div>

            <div class="font-medium">
              {{ cabeceraTimeline.Tarea || 'No disponible' }}
            </div>

          </div>


          <!-- ===================================== -->
          <!-- Agencia -->
          <!-- ===================================== -->

          <div>

            <div class="text-xs text-color-secondary">
              Agencia
            </div>

            <div class="font-medium">
              {{ cabeceraTimeline.NombreAgencia || 'No disponible' }}
            </div>

          </div>


          <!-- ===================================== -->
          <!-- Tipo documental -->
          <!-- ===================================== -->

          <div>

            <div class="text-xs text-color-secondary">
              Tipo documental
            </div>

            <div class="font-medium">
              {{ cabeceraTimeline.NombreTipoDocumento || 'No disponible' }}
            </div>

          </div>


          <!-- ===================================== -->
          <!-- Radicado -->
          <!-- ===================================== -->

          <div>

            <div class="text-xs text-color-secondary">
              Radicado
            </div>

            <div class="font-medium">
              {{ cabeceraTimeline.CodRadicado || 'No disponible' }}
            </div>

          </div>


          <!-- ===================================== -->
          <!-- Usuario -->
          <!-- ===================================== -->

          <div>

            <div class="text-xs text-color-secondary">
              Usuario
            </div>

            <div class="font-medium">
              {{
                cabeceraTimeline.CodUserNombre ||
                cabeceraTimeline.CodUser ||
                'No disponible'
              }}
            </div>

          </div>


          <!-- ===================================== -->
          <!-- Fecha -->
          <!-- ===================================== -->

          <div>

            <div class="text-xs text-color-secondary">
              Fecha registro
            </div>

            <div class="font-medium">
              {{
                formatearFecha(
                  cabeceraTimeline.FechaRegistro
                )
              }}
            </div>

          </div>

        </div>

      </p-accordion-content>

    </p-accordion-panel>

  </p-accordion>

</div>

  <!-- ======================================================= -->
  <!-- LOADING                                                 -->
  <!-- ======================================================= -->

  <div
    *ngIf="loadingTimeline"
    class="
      flex
      flex-col
      items-center
      justify-center
      py-12
      gap-3
    "
  >

    <p-progressSpinner
      strokeWidth="4"
      styleClass="w-10 h-10"
    >
    </p-progressSpinner>

    <span class="text-sm text-color-secondary">
      Cargando trazabilidad del documento...
    </span>

  </div>


  <!-- ======================================================= -->
  <!-- SIN INFORMACIÓN                                         -->
  <!-- ======================================================= -->

  <div
    *ngIf="!loadingTimeline && timeline.length === 0"
    class="
      flex
      flex-col
      items-center
      justify-center
      py-12
      gap-3
      rounded-xl
      border
      border-surface-200
      bg-surface-50
    "
  >

    <i
      class="
        pi
        pi-history
        text-4xl
        text-color-secondary
      "
    >
    </i>

    <div class="font-semibold">
      Sin trazabilidad
    </div>

    <div class="text-sm text-color-secondary">
      No se encontraron movimientos para este documento.
    </div>

  </div>


  <!-- ======================================================= -->
  <!-- TIMELINE                                                -->
  <!-- ======================================================= -->

  <div
    *ngIf="!loadingTimeline && timeline.length > 0"
    class="flex-1 overflow-auto pr-2"
  >

    <p-timeline
      [value]="timeline"
      align="left"
      styleClass="custom-timeline"
    >


      <!-- =================================================== -->
      <!-- MARKER                                               -->
      <!-- =================================================== -->

      <ng-template
        pTemplate="marker"
        let-event
      >

        <div
          class="
            flex
            items-center
            justify-center
            w-10
            h-10
            rounded-full
            border-2
            border-white
            shadow-sm
          "
          [ngClass]="event.markerClass"
        >

          <i
            [class]="event.icon"
          >
          </i>

        </div>

      </ng-template>


      <!-- =================================================== -->
      <!-- OPPOSITE                                            -->
      <!-- =================================================== -->

      <ng-template
        pTemplate="opposite"
        let-event
      >

        <div class="text-sm">

          <div class="font-semibold">
            {{ event.estado }}
          </div>

          <div class="text-xs text-color-secondary mt-1">
            {{
              formatearFecha(
                event.fecha
              )
            }}
          </div>

        </div>

      </ng-template>


      <!-- =================================================== -->
      <!-- CONTENT                                             -->
      <!-- =================================================== -->

      <ng-template
        pTemplate="content"
        let-event
      >

        <div
          class="
            mb-6
            rounded-xl
            border
            border-surface-200
            bg-white
            shadow-sm
            overflow-hidden
          "
        >

          <!-- =============================================== -->
          <!-- RESUMEN EVENTO                                   -->
          <!-- =============================================== -->

          <div
            class="
              p-4
              flex
              flex-col
              md:flex-row
              md:items-start
              md:justify-between
              gap-3
              cursor-pointer
              hover:bg-surface-50
            "
            (click)="
              event.expanded =
                !event.expanded
            "
          >

            <div class="flex items-start gap-3">

              <!-- ICONO -->

              <div
                class="
                  flex
                  items-center
                  justify-center
                  w-10
                  h-10
                  rounded-full
                  shrink-0
                "
                [ngClass]="event.markerClass"
              >

                <i
                  [class]="event.icon"
                >
                </i>

              </div>


              <!-- INFORMACIÓN -->

              <div class="min-w-0">

                <div class="flex items-center gap-2 flex-wrap">

                  <span class="font-semibold">
                    {{ event.descripcion }}
                  </span>

                  <p-tag
                    [value]="event.estado || 'Sin estado'"
                    [severity]="event.severity"
                  >
                  </p-tag>

                </div>


                <div
                  *ngIf="event.accion"
                  class="
                    text-sm
                    text-color-secondary
                    mt-1
                  "
                >
                  {{ event.accion }}
                </div>


                <div
                  class="
                    flex
                    flex-wrap
                    gap-x-4
                    gap-y-1
                    mt-2
                    text-xs
                    text-color-secondary
                  "
                >

                  <span>
                    <i class="pi pi-calendar mr-1"></i>
                    {{
                      formatearFecha(
                        event.fecha
                      )
                    }}
                  </span>


                  <span>
                    <i class="pi pi-user mr-1"></i>
                    {{ event.usuario || 'Sistema' }}
                  </span>


                  <span
                    *ngIf="event.dependencia"
                  >
                    <i class="pi pi-building mr-1"></i>
                    {{ event.dependencia }}
                  </span>


                  <span
                    *ngIf="event.consecutivo"
                  >
                    <i class="pi pi-hashtag mr-1"></i>
                    {{ event.consecutivo }}
                  </span>

                </div>

              </div>

            </div>


            <!-- EXPANDIR -->

            <div
              class="
                flex
                items-center
                justify-center
                w-8
                h-8
                rounded-full
                hover:bg-surface-100
                shrink-0
              "
            >

              <i
                class="pi"
                [ngClass]="
                  event.expanded
                    ? 'pi-chevron-up'
                    : 'pi-chevron-down'
                "
              >
              </i>

            </div>

          </div>


          <!-- =============================================== -->
          <!-- DETALLE DEL REGISTRO                            -->
          <!-- =============================================== -->

          <div
            *ngIf="event.expanded"
            class="
              border-t
              border-surface-200
              p-4
              bg-surface-50
            "
          >

            <div class="flex flex-col gap-5">


              <!-- ========================================= -->
              <!-- FLUJO DOCUMENTAL                          -->
              <!-- ========================================= -->

              <div>

                <div
                  class="
                    flex
                    items-center
                    gap-2
                    mb-3
                  "
                >

                  <i
                    class="pi pi-sitemap text-primary"
                  >
                  </i>

                  <span class="font-semibold">
                    Flujo documental
                  </span>

                </div>


                <div
                  class="
                    grid
                    grid-cols-1
                    md:grid-cols-2
                    lg:grid-cols-3
                    gap-2
                  "
                >

                  <!-- Flujo -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Flujo
                    </div>

                    <div class="font-medium">
                      {{
                        getValue(
                          event.original,
                          'CabeceraNombreFlujo'
                        )
                      }}
                    </div>

                  </div>


                  <!-- Código Cabecera -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Código Cabecera
                    </div>

                    <div class="font-medium">
                      {{
                        getValue(
                          event.original,
                          'CodfdCabecera'
                        )
                      }}
                    </div>

                  </div>


                  <!-- Cuerpo -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Código Cuerpo
                    </div>

                    <div class="font-medium">
                      {{
                        getValue(
                          event.original,
                          'CodfdCuerpo'
                        )
                      }}
                    </div>

                  </div>


                  <!-- Paso -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Paso
                    </div>

                 <div class="font-medium">
                  {{
                    getValue(event.original, 'IdfdPaso')
                      ? getValue(event.original, 'IdfdPaso') + ' - '
                      : ''
                  }}
                  {{
                    getValue(event.original, 'NombrePaso') || 'No disponible'
                  }}
                </div>

                  </div>


                  <!-- Tarea -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Tarea
                    </div>

                    <div class="font-medium">
                      {{
                        getValue(
                          event.original,
                          'Tarea'
                        )
                      }}
                    </div>

                  </div>


                  <!-- Perfil -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Perfil asignado
                    </div>

                    <div class="font-medium">
                      {{
                        getValue(
                          event.original,
                          'NombrePerfilAsignado'
                        )
                      }}
                    </div>

                  </div>


                  <!-- Agencia -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Agencia
                    </div>

                    <div class="font-medium">
                      {{
                        getValue(
                          event.original,
                          'NombreAgencia'
                        )
                      }}
                    </div>

                  </div>


                  <!-- Código Global -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Código Global
                    </div>

                    <div class="font-medium">
                      {{
                        getValue(
                          event.original,
                          'CodGlobal'
                        )
                      }}
                    </div>

                  </div>


                  <!-- Ruta -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Ruta
                    </div>

                    <div class="font-medium">
                      {{
                        getValue(
                          event.original,
                          'CodfdRutas'
                        )
                      }}
                    </div>

                  </div>
                  
                  <!-- Visualizar -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">
                    <div class="text-xs text-color-secondary">
                      Visualizar
                    </div>
                    <div class="font-medium">
                      {{
                        getValue(
                          event.original,
                          'Visualizar'
                        )
                      }}
                    </div>
                  </div>

                  <!-- OcultarmeSi -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">
                    <div class="text-xs text-color-secondary">
                      Oculto?
                    </div>
                    <div class="font-medium">
                      {{
                        getValue(
                          event.original,
                          'OcultarmeSi'
                        )
                      }}
                    </div>
                  </div>

                   <!-- DevueltoAreaAnterior -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">
                    <div class="text-xs text-color-secondary">
                      DevueltoAreaAnterior?
                    </div>
                    <div class="font-medium">
                      {{
                        getValue(
                          event.original,
                          'DevueltoAreaAnterior'
                        )
                      }}
                    </div>
                  </div>



                </div>

              </div>


              <!-- ========================================= -->
              <!-- IDENTIFICACIÓN DEL DOCUMENTO              -->
              <!-- ========================================= -->

              <div>

                <div
                  class="
                    flex
                    items-center
                    gap-2
                    mb-3
                  "
                >

                  <i
                    class="pi pi-file text-primary"
                  >
                  </i>

                  <span class="font-semibold">
                    Identificación del documento
                  </span>

                </div>


                <div
                  class="
                    grid
                    grid-cols-1
                    md:grid-cols-2
                    lg:grid-cols-3
                    gap-2
                  "
                >

                  <!-- ID Archivo -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Id archivo
                    </div>

                    <div class="font-medium">
                      {{
                        getValue(
                          event.original,
                          'IdfdArchivo'
                        )
                      }}
                    </div>

                  </div>


                  <!-- Tipo documental -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Tipo documental
                    </div>

                    <div class="font-medium">
                      {{
                        getValue(
                          event.original,
                          'NombreTipoDocumento'
                        )
                      }}
                    </div>

                  </div>


                  <!-- Tipo documento -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Tipo documento
                    </div>

                    <div class="font-medium">
                      {{
                        getValue(
                          event.original,
                          'TipoDocumento'
                        )
                      }}
                    </div>

                  </div>


                  <!-- Radicado -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Radicado
                    </div>

                    <div class="font-medium">
                      {{
                        getValue(
                          event.original,
                          'CodRadicado'
                        )
                      }}
                    </div>

                  </div>


                  <!-- Código único -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Código único
                    </div>

                    <div class="font-medium">
                      {{
                        getValue(
                          event.original,
                          'CmpoCodigoUnico'
                        )
                      }}
                    </div>

                  </div>


                  <!-- Factura -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Código factura
                    </div>

                    <div class="font-medium">
                      {{
                        getValue(
                          event.original,
                          'CmpoCodigoFactura'
                        )
                      }}
                    </div>

                  </div>


                  <!-- Cédula -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Cédula / Identificación
                    </div>

                    <div class="font-medium">
                      {{
                        getValue(
                          event.original,
                          'CmpoCedula'
                        )
                      }}
                    </div>

                  </div>


                  <!-- Proveedor -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Proveedor
                    </div>

                    <div class="font-medium">
                      {{
                        getValue(
                          event.original,
                          'NombrecmpoCodProveedor'
                        )
                      }}
                    </div>

                    <div class="text-xs text-color-secondary mt-1">
                      Código:
                      {{
                        getValue(
                          event.original,
                          'CmpoCodProveedor'
                        )
                      }}
                    </div>

                  </div>


                  <!-- Archivo -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Archivo
                    </div>

                    <div
                      class="font-medium truncate"
                      [title]="
                        getValue(
                          event.original,
                          'NombreArchivo'
                        )
                      "
                    >
                      {{
                        getValue(
                          event.original,
                          'NombreArchivo'
                        )
                      }}
                    </div>

                  </div>

                </div>

              </div>


              <!-- ========================================= -->
              <!-- ESTADOS                                   -->
              <!-- ========================================= -->

              <div>

                <div
                  class="
                    flex
                    items-center
                    gap-2
                    mb-3
                  "
                >

                  <i
                    class="pi pi-check-circle text-primary"
                  >
                  </i>

                  <span class="font-semibold">
                    Estados del documento
                  </span>

                </div>


                <div
                  class="
                    grid
                    grid-cols-1
                    md:grid-cols-2
                    lg:grid-cols-3
                    gap-2
                  "
                >

                  <!-- Estado Documento -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Estado documento
                    </div>

                    <p-tag
                      [value]="
                        getValue(
                          event.original,
                          'EstadoDocumento'
                        ) || 'No disponible'
                      "
                      severity="info"
                    >
                    </p-tag>

                  </div>


                  <!-- Estado Contable -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Estado contable
                    </div>

                    <p-tag
                      [value]="
                        getValue(
                          event.original,
                          'EstadoContable'
                        ) || 'No disponible'
                      "
                      severity="success"
                    >
                    </p-tag>

                  </div>


                  <!-- Estado Pago -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Estado pago
                    </div>

                    <p-tag
                      [value]="
                        getValue(
                          event.original,
                          'EstadoPago'
                        ) || 'No disponible'
                      "
                      severity="warn"
                    >
                    </p-tag>

                  </div>


                  <!-- Estado Orden Pago -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Estado orden de pago
                    </div>

                    <p-tag
                      [value]="
                        getValue(
                          event.original,
                          'EstadoOrdenPago'
                        ) || 'No disponible'
                      "
                      severity="secondary"
                    >
                    </p-tag>

                  </div>


                  <!-- Estado Expediente -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Estado expediente
                    </div>

                    <p-tag
                      [value]="
                        getValue(
                          event.original,
                          'EstadoExpediente'
                        ) || 'No disponible'
                      "
                      severity="contrast"
                    >
                    </p-tag>

                  </div>

                </div>

              </div>


              <!-- ========================================= -->
              <!-- INFORMACIÓN ECONÓMICA                      -->
              <!-- ========================================= -->

              <div>

                <div
                  class="
                    flex
                    items-center
                    gap-2
                    mb-3
                  "
                >

                  <i
                    class="pi pi-dollar text-primary"
                  >
                  </i>

                  <span class="font-semibold">
                    Información económica
                  </span>

                </div>


                <div
                  class="
                    grid
                    grid-cols-1
                    md:grid-cols-2
                    lg:grid-cols-3
                    gap-2
                  "
                >

                  <!-- Valor -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Valor
                    </div>

                    <div class="font-semibold">
                      {{
                        formatearMoneda(
                          getValue(
                            event.original,
                            'CmpoValor'
                          )
                        )
                      }}
                    </div>

                  </div>


                  <!-- Valor a pagar -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Valor a pagar
                    </div>

                    <div class="font-semibold">
                      {{
                        formatearMoneda(
                          getValue(
                            event.original,
                            'CmpoValoraPagar'
                          )
                        )
                      }}
                    </div>

                  </div>


                  <!-- Valor PAD -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Valor PAD
                    </div>

                    <div class="font-semibold">
                      {{
                        formatearMoneda(
                          getValue(
                            event.original,
                            'CmpoValorPAD'
                          )
                        )
                      }}
                    </div>

                  </div>

                </div>

              </div>


              <!-- ========================================= -->
              <!-- FECHAS                                    -->
              <!-- ========================================= -->

              <div>

                <div
                  class="
                    flex
                    items-center
                    gap-2
                    mb-3
                  "
                >

                  <i
                    class="pi pi-calendar text-primary"
                  >
                  </i>

                  <span class="font-semibold">
                    Fechas importantes
                  </span>

                </div>


                <div
                  class="
                    grid
                    grid-cols-1
                    md:grid-cols-2
                    lg:grid-cols-3
                    gap-2
                  "
                >

                  <!-- Fecha documento -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Fecha documento
                    </div>

                    <div class="font-medium">
                      {{
                        formatearFecha(
                          getValue(
                            event.original,
                            'CmpoFechaDocumento'
                          )
                        )
                      }}
                    </div>

                  </div>


                  <!-- Fecha pago -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Pago oportuno
                    </div>

                    <div class="font-medium">
                      {{
                        formatearFecha(
                          getValue(
                            event.original,
                            'CmpoFechaPagoOportuno'
                          )
                        )
                      }}
                    </div>

                  </div>


                  <!-- Fecha registro -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Fecha registro
                    </div>

                    <div class="font-medium">
                      {{
                        formatearFecha(
                          getValue(
                            event.original,
                            'FechaRegistro'
                          )
                        )
                      }}
                    </div>

                  </div>


                  <!-- Fecha actualización -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Última actualización
                    </div>

                    <div class="font-medium">
                      {{
                        formatearFecha(
                          getValue(
                            event.original,
                            'FechaRegistroUpdate'
                          )
                        )
                      }}
                    </div>

                  </div>


                  <!-- Fecha histórico -->

                  <div
                    *ngIf="
                      getValue(
                        event.original,
                        'FechaRegistroHistorico'
                      ) !== 'No disponible'
                    "
                    class="p-3 rounded-lg bg-white border border-surface-200"
                  >

                    <div class="text-xs text-color-secondary">
                      Fecha movimiento histórico
                    </div>

                    <div class="font-medium">
                      {{
                        formatearFecha(
                          getValue(
                            event.original,
                            'FechaRegistroHistorico'
                          )
                        )
                      }}
                    </div>

                  </div>


                  <!-- Fecha vencimiento -->

                  <div
                    *ngIf="
                      getValue(
                        event.original,
                        'FECHA_VENCIMIENTO'
                      ) !== 'No disponible'
                    "
                    class="p-3 rounded-lg bg-white border border-surface-200"
                  >

                    <div class="text-xs text-color-secondary">
                      Fecha vencimiento
                    </div>

                    <div class="font-medium">
                      {{
                        formatearFecha(
                          getValue(
                            event.original,
                            'FECHA_VENCIMIENTO'
                          )
                        )
                      }}
                    </div>

                  </div>


                  <!-- Último abono -->

                  <div
                    *ngIf="
                      getValue(
                        event.original,
                        'FECHA_ULT_ABONO'
                      ) !== 'No disponible'
                    "
                    class="p-3 rounded-lg bg-white border border-surface-200"
                  >

                    <div class="text-xs text-color-secondary">
                      Último abono
                    </div>

                    <div class="font-medium">
                      {{
                        formatearFecha(
                          getValue(
                            event.original,
                            'FECHA_ULT_ABONO'
                          )
                        )
                      }}
                    </div>

                  </div>

                </div>

              </div>


              <!-- ========================================= -->
              <!-- USUARIOS                                  -->
              <!-- ========================================= -->

              <div>

                <div
                  class="
                    flex
                    items-center
                    gap-2
                    mb-3
                  "
                >

                  <i
                    class="pi pi-users text-primary"
                  >
                  </i>

                  <span class="font-semibold">
                    Usuarios involucrados
                  </span>

                </div>


                <div
                  class="
                    grid
                    grid-cols-1
                    md:grid-cols-2
                    lg:grid-cols-3
                    gap-2
                  "
                >

                  <!-- Usuario registro -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Usuario registro
                    </div>

                    <div class="font-medium">
                      {{
                        getValue(
                          event.original,
                          'CodUserNombre'
                        )
                      }}
                    </div>

                    <div class="text-xs text-color-secondary mt-1">
                      {{
                        getValue(
                          event.original,
                          'CodUser'
                        )
                      }}
                    </div>

                  </div>


                  <!-- Usuario procesador -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Usuario procesador
                    </div>

                    <div class="font-medium">
                      {{
                        getValue(
                          event.original,
                          'CodUserProcesadorNombre'
                        )
                      }}
                    </div>

                    <div class="text-xs text-color-secondary mt-1">
                      {{
                        getValue(
                          event.original,
                          'CodUserProcesador'
                        )
                      }}
                    </div>

                  </div>


                  <!-- Usuario actualización -->

                  <div class="p-3 rounded-lg bg-white border border-surface-200">

                    <div class="text-xs text-color-secondary">
                      Usuario actualización
                    </div>

                    <div class="font-medium">
                      {{
                        getValue(
                          event.original,
                          'CodUserUpdateNombre'
                        )
                      }}
                    </div>

                    <div class="text-xs text-color-secondary mt-1">
                      {{
                        getValue(
                          event.original,
                          'CodUserUpdate'
                        )
                      }}
                    </div>

                  </div>

                </div>

              </div>


              <!-- ========================================= -->
              <!-- OBSERVACIÓN                               -->
              <!-- ========================================= -->

              <div
                *ngIf="tieneObservacion(event)"
                class="
                  p-4
                  rounded-lg
                  border
                  border-surface-200
                  bg-white
                "
              >

                <div
                  class="
                    flex
                    items-center
                    gap-2
                    mb-2
                  "
                >

                  <i
                    class="pi pi-comment text-primary"
                  >
                  </i>

                  <span class="font-semibold">
                    Observación
                  </span>

                </div>


                <div class="text-sm text-color-secondary">

                  {{
                    getValue(
                      event.original,
                      'CmpoObservacion'
                    )
                  }}

                </div>

              </div>

            </div>

          </div>

        </div>

      </ng-template>

    </p-timeline>

  </div>

</div>